/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ countdown: NonNullable<unknown> }} Game_Today_Finished_ResetInputs */

const bn_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আপনি ইতিমধ্যে আজকের রান শেষ. পরবর্তী রিসেট ${i?.countdown} (UTC) এ।`)
};

const de_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast den heutigen Lauf bereits beendet. Nächstes Zurücksetzen in ${i?.countdown} (UTC).`)
};

const el_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ολοκληρώσατε ήδη το σημερινό τρέξιμο. Επόμενη επαναφορά σε ${i?.countdown} (UTC).`)
};

const en_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You already finished today's run. Next reset in ${i?.countdown} (UTC).`)
};

const es_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ya terminaste la carrera de hoy. Próximo reinicio en ${i?.countdown} (UTC).`)
};

const fr_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez déjà terminé la partie d’aujourd’hui. Prochaine réinitialisation dans ${i?.countdown} (UTC).`)
};

const hi_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपने आज की दौड़ पहले ही पूरी कर ली है। अगला रीसेट ${i?.countdown} (UTC) में होगा।`)
};

const hu_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Már befejezted a mai futást. Következő visszaállítás ${i?.countdown} (UTC) múlva.`)
};

const id_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda sudah menyelesaikan lari hari ini. Setel ulang berikutnya di ${i?.countdown} (UTC).`)
};

const it_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai già finito la corsa di oggi. Prossimo ripristino tra ${i?.countdown} (UTC).`)
};

const ja_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あなたはすでに今日のランニングを終えました。次に ${i?.countdown} (UTC) にリセットします。`)
};

const ko_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`오늘의 달리기를 이미 마쳤습니다. 다음 재설정은 ${i?.countdown}(UTC)입니다.`)
};

const nl_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je hebt de run van vandaag al voltooid. Volgende reset over ${i?.countdown} (UTC).`)
};

const pl_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skończyłeś już dzisiejszy bieg. Następny reset za ${i?.countdown} (UTC).`)
};

const pt_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você já terminou a corrida de hoje. Próxima redefinição em ${i?.countdown} (UTC).`)
};

const ru_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уже завершили сегодняшний забег. Следующий сброс в ${i?.countdown} (UTC).`)
};

const sv_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har redan avslutat dagens löpning. Nästa återställning om ${i?.countdown} (UTC).`)
};

const tr_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bugünkü koşuyu zaten tamamladınız. Sonraki sıfırlama ${i?.countdown} (UTC) tarihinde yapılacak.`)
};

const uk_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ви вже завершили сьогоднішню пробіжку. Наступне скидання через ${i?.countdown} (UTC).`)
};

const vi_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bạn đã hoàn thành cuộc chạy ngày hôm nay. Lần đặt lại tiếp theo sau ${i?.countdown} (UTC).`)
};

const zh_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你已经完成了今天的跑步。下次重置时间为 ${i?.countdown} (UTC)。`)
};

const zh_hant_game_today_finished_reset = /** @type {(inputs: Game_Today_Finished_ResetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你已經完成了今天的跑步。下次重置時間為 ${i?.countdown} (UTC)。`)
};

/**
* | output |
* | --- |
* | "You already finished today's run. Next reset in {countdown} (UTC)." |
*
* @param {Game_Today_Finished_ResetInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_today_finished_reset = /** @type {((inputs: Game_Today_Finished_ResetInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Today_Finished_ResetInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_today_finished_reset(inputs)
	if (locale === "de") return de_game_today_finished_reset(inputs)
	if (locale === "el") return el_game_today_finished_reset(inputs)
	if (locale === "en") return en_game_today_finished_reset(inputs)
	if (locale === "es") return es_game_today_finished_reset(inputs)
	if (locale === "fr") return fr_game_today_finished_reset(inputs)
	if (locale === "hi") return hi_game_today_finished_reset(inputs)
	if (locale === "hu") return hu_game_today_finished_reset(inputs)
	if (locale === "id") return id_game_today_finished_reset(inputs)
	if (locale === "it") return it_game_today_finished_reset(inputs)
	if (locale === "ja") return ja_game_today_finished_reset(inputs)
	if (locale === "ko") return ko_game_today_finished_reset(inputs)
	if (locale === "nl") return nl_game_today_finished_reset(inputs)
	if (locale === "pl") return pl_game_today_finished_reset(inputs)
	if (locale === "pt") return pt_game_today_finished_reset(inputs)
	if (locale === "ru") return ru_game_today_finished_reset(inputs)
	if (locale === "sv") return sv_game_today_finished_reset(inputs)
	if (locale === "tr") return tr_game_today_finished_reset(inputs)
	if (locale === "uk") return uk_game_today_finished_reset(inputs)
	if (locale === "vi") return vi_game_today_finished_reset(inputs)
	if (locale === "zh") return zh_game_today_finished_reset(inputs)
	return zh_hant_game_today_finished_reset(inputs)
});